import { create } from 'zustand';

export interface User {
  id: string;
  email: string;
  name: string;
  avatar?: string;
  role: 'admin' | 'user' | 'viewer';
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
}

/**
 * @deprecated Legacy auth store — kept only as fallback for `getCurrentUserId()` in
 * useQueryStore. Real authentication uses MSAL.js (see `src/auth/msal-config.ts`).
 * Do NOT add new usages. Will be removed once all consumers migrate to MSAL hooks.
 */
export const useAuthStore = create<AuthState>()(() => ({
  user: null,
  isAuthenticated: false,
}));
